import {Injectable} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {EMAIL_PATTERN, PHONE_NUMBER_PATTERN} from '../../shared';

@Injectable({
  providedIn: 'root'
})
export class GetFormsServiceLocal {

  constructor(private fb: FormBuilder) {
  }

  getRemovePlayer(): FormGroup {
    return this.fb.group({
      playerList: this.fb.group({
        deviceID: [null, Validators.required],
        reason: [null],
      })
    });
  }
  getRemovePlayerLostOrSold(): FormGroup {
    return this.fb.group({
        reason: [null],
    });
  }
  getContacts(): FormGroup {
    return this.fb.group({
      contacts: this.fb.array([
        this.getContact()
      ]),
    })
  }
  getMergeSiteOfClient(): FormGroup {
    return this.fb.group({
      clientName: [null, Validators.required],
      clientUuid: [null, Validators.required],
    });
  }
  getMergeSubscriptionOfSite(): FormGroup {
    return this.fb.group({
      siteName: [null, Validators.required],
      siteUuid: [null, Validators.required],
    });
  }
  getMergeSubscriptionOfNewSite(): FormGroup {
    return this.fb.group({
      NewSiteName: [null, Validators.required],
      NewSiteUuid: [null],
      NewSiteExternalID: [null],
    });
  }
  getBulkUpdate(): FormGroup {
    return this.fb.group({
      status: this.fb.group({
      id: [null, Validators.required]
    })
    });
  }

  getContact(): FormGroup {
    return this.fb.group({
      comments: [null],
      culture: [null],
      created: [null],
      createdBy: [null],
      department: [null],
      email: [null, Validators.pattern(EMAIL_PATTERN)],
      groupRole: [null],
      id: [null],
      mobile: [null, Validators.pattern(PHONE_NUMBER_PATTERN)],
      name: [null, Validators.required],
      phone: [null, [Validators.required, Validators.pattern(PHONE_NUMBER_PATTERN)]],
      sex: [null],
      skype: [null],
      surname: [null],
      typeUser: [null],
      uuid: [null],
      updated: [null],
      updatedBy: [null]
    })
  }

}


